import { Box, Button, makeStyles, TextField } from "@material-ui/core";
import { useState } from "react";
import { CryptoState } from "../CryptoContext";
import { createUserWithEmailAndPassword } from "@firebase/auth";
import { auth } from "../firebase";

const useStyles = makeStyles(() => ({
  signupContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px"
  }
}));

function Signup({ handleClose }) {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setContfirmPassword] = useState("");

  const { setAlert } = CryptoState();

  const handleSubmit = async () => {
    if (password !== confirmPassword) {
      setAlert({
        open: true,
        message: "Passwords do not match!",
        type: "error"
      });
      return;
    }

    try {
      const result = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      setAlert({
        open: true,
        message: `Sign up succesful.  Welcome ${result.user.email}`,
        type: "success"
      });

      handleClose();
    } catch (error) {
      setAlert({
        open: true,
        message: error.message,
        type: "error"
      });
    }
  };

  return (
    <Box p={3} className={classes.signupContainer}>
      <TextField
        variant="outlined"
        type="email"
        label="Enter Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        fullWidth
      />
      <TextField
        variant="outlined"
        type="password"
        label="Enter Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
      />
      <TextField
        variant="outlined"
        type="password"
        label="Confirm Password"
        value={confirmPassword}
        onChange={(e) => setContfirmPassword(e.target.value)}
        fullWidth
      />
      <Button
        variant="contained"
        size="large"
        style={{ backgroundColor: "#eebc1d" }}
        onClick={handleSubmit}
      >
        Sign up
      </Button>
    </Box>
  );
}

export default Signup;
